
<template>
  <div class="room report-list" v-loading="loading" ref="room">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="table-command">
      <el-button @click="triggerCreateUserDialog()" v-if="isAdmin" type="primary">创建用户</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%" :max-height="tableMaxHeight">
      <el-table-column align="center" label="序号" type="index" width="100"></el-table-column>
      <el-table-column align="center" label="用户ID" prop="userId" width="200"></el-table-column>
      <el-table-column align="center" label="用户名" prop="userName" width="200"></el-table-column>
      <el-table-column align="center" label="用户类型" prop="userType" width="100"></el-table-column>
      <el-table-column align="center" label="权限桥" prop="authBridge"></el-table-column>
      <!-- <el-table-column align="center" label="遥控桥" prop="controllBridge"></el-table-column> -->
      <el-table-column align="center" label="最近登录时间" prop="lastLoginDate" width="200"></el-table-column>
      <el-table-column align="center" label="登陆地点" prop="lastLoginLocation" width="200">
        <!-- <template slot-scope="scope">
          <p>{{scope.row.lastLoginIp}}</p>
          <p v-if="scope.row.lastLoginLocation">{{scope.row.lastLoginLocation}}</p>
        </template> -->
      </el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            class="table-button"
            size="small"
            type="primary"
            @click="triggerSetAuthBridge(scope.row.userId)"
            :disabled="scope.row.IsAdmin"
            v-if="isAdmin"
            >配置权限桥</el-button
          >
          <el-button
            class="table-button"
            size="small"
            type="primary"
            @click="triggerSetControllBridge(scope.row.userId)"
            :disabled="scope.row.IsAdmin"
            v-if="isAdmin"
            >配置遥控桥</el-button
          >
          <el-button class="table-button" size="small" type="primary" @click="triggerLoginHistory(scope.row.userId)">登陆记录</el-button>
          <el-button class="table-button" size="small" type="danger" @click="triggerChangePassword(scope.row.userId)">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      :style="pageStyle"
      layout="prev, pager, next"
      :total="totalCount"
      :page-size="pageSize"
      @current-change="currentChange"
      ref="page"
    ></el-pagination>
    <!-- 新建用户弹窗 -->
    <el-dialog title="新建用户" :visible.sync="createUserDialogVisible" width="30%" v-loading="changePasswordDialogLoading">
      <el-form :model="createUserModel" v-loading="createUserFormLoading" ref="createUserForm" :rules="createUserFormRules" label-width="80px">
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="createUserModel.userId" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="createUserModel.userName" placeholder="请输入中文名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="createUserModel.password" placeholder="请输入密码" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createUserDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCreateUser">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 重置密码弹窗 -->
    <el-dialog title="重置密码" :visible.sync="changePasswordDialogVisible" width="30%" v-loading="changePasswordDialogLoading">
      <el-form :model="changePasswordModel" ref="resetPasswordForm" :rules="resetPasswordFormRules" label-width="80px">
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="changePasswordModel.userId" placeholder="用户ID" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="changePasswordModel.userName" placeholder="用户名" readonly></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="changePasswordModel.newPassword" placeholder="请输入新密码" type="password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePasswordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submieChangePassword">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 配置权限桥弹窗 -->
    <el-dialog
      :title="setAuthBridgeModel.isSetControllBridge ? '配置遥控桥' : '配置权限桥'"
      :visible.sync="setAuthBridgeDialogVisible"
      width="35%"
      v-loading="setAuthBridgeDialogLoading"
    >
      <el-form :model="setAuthBridgeModel" ref="setAuthBridgeForm" label-width="80px">
        <el-form-item>
          <el-checkbox-group v-model="setAuthBridgeModel.selectedBridgeList">
            <el-checkbox v-for="bridgeId in setAuthBridgeModel.displayBridgeIdList" :key="bridgeId" :label="bridgeId" :name="bridgeId">{{
              bridgeIdBridgeNameDict[bridgeId]
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setAuthBridgeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSetAuthBridge">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Bridge as constantBridgeList } from "./../constants";
import { dateTimeToString, newtonsoftJsonToDate } from "../tools/GeneralTool";

export default {
  name: "UserControl",
  data() {
    return {
      loadingFullScreen: null,
      timer: null,
      isAdmin: false,
      tableData: [],
      userIdUserDict: {},
      bridgeIdBridgeNameDict: null,
      loading: false,
      shownewUser: false,
      checkUserId: "",
      totalCount: 1,
      currentPage: 1,
      pageSize: 10,
      userTranslateDict: {},
      deviceNameReplaceList: ["状态", "(枚举)"],
      tableMaxHeight: 777,
      clientHeight: 0,
      pageStyle: {},
      paginationHeight: 70,
      showAllUser: false,
      createUserDialogVisible: false,
      createUserFormLoading: false,
      createUserModel: {
        userId: "",
        userName: "",
        password: "",
      },
      changePasswordModel: {
        userId: "",
        userName: "",
        newPassword: "",
      },
      changePasswordDialogVisible: false,
      changePasswordDialogLoading: false,
      createUserFormRules: {
        userId: [{ required: true, message: "请输入用户ID", trigger: "blur" }],
        userName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      resetPasswordFormRules: {
        newPassword: [{ required: true, message: "请输入新密码", trigger: "blur" }],
      },
      setAuthBridgeDialogVisible: false,
      setAuthBridgeDialogLoading: false,
      setAuthBridgeModel: {
        userId: "",
        selectedBridgeList: [],
        displayBridgeIdList: [],
        isSetControllBridge: false,
      },
    };
  },
  computed: {
    bridgeIdBridgeNameDictKeyList() {
      if (!this.bridgeIdBridgeNameDict) {
        return [];
      }

      return Object.keys(this.bridgeIdBridgeNameDict);
    },
  },
  created() {
    this.$http.get("/auth/LoginInfo").then((res) => {
      if (res !== undefined && res.data !== undefined) {
        this.isAdmin = res.data.IsAdmin;
      }
    });
  },
  mounted() {
    this.getData();

    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);

    window.onresize = () => {
      this.clientHeight = document.documentElement.clientHeight;
    };
    this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    this.pageStyle = {
      left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
    };
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  watch: {
    clientHeight(newVal, oldVal) {
      this.tableMaxHeight = this.$refs.room.offsetHeight - this.paginationHeight;
    },
    createUserDialogVisible(newVal, oldVal) {
      if (newVal) {
        this.$refs.createUserForm.resetFields();
      }
    },
    totalCount() {
      this.$nextTick().then(() => {
        this.pageStyle = {
          left: (this.$refs.room.clientWidth - this.$refs.page.$el.clientWidth) / 2 + "px",
        };
      });
    },
  },
  methods: {
    downloadImportTemplate() {
      window.open("/report/DownloadImportTemplate", "_blank");
    },
    submitSetAuthBridge() {
      this.setAuthBridgeDialogLoading = true;
      let postBody = {};
      postBody.userId = this.setAuthBridgeModel.userId;
      if (this.setAuthBridgeModel.isSetControllBridge) {
        postBody.controlledBridgeList = this.setAuthBridgeModel.selectedBridgeList;
      } else {
        postBody.authorisedBridgeList = this.setAuthBridgeModel.selectedBridgeList;
      }

      let url = "/user/UpdateAuthorisedBridge";
      let message = "配置权限桥成功";
      if (this.setAuthBridgeModel.isSetControllBridge) {
        url = "/user/UpdateControlledBridge";
        message = "配置遥控桥成功";
      }

      this.$http
        .post(url, postBody)
        .then(() => {
          this.$message({
            message: message,
            type: "success",
          });
          this.setAuthBridgeDialogLoading = false;
          this.setAuthBridgeDialogVisible = false;
          this.getData();
        })
        .catch(() => {
          this.setAuthBridgeDialogLoading = false;
        });
    },
    submieChangePassword() {
      this.$refs.resetPasswordForm.validate().then(() => {
        let postBody = {
          userId: this.changePasswordModel.userId,
          password: this.changePasswordModel.newPassword,
        };

        this.changePasswordDialogLoading = true;
        this.$http
          .post("/user/UpdatePassword", postBody)
          .then(() => {
            this.changePasswordDialogLoading = false;
            this.changePasswordDialogVisible = false;
            this.getData();
            this.$message({ message: "修改成功", type: "success" });
          })
          .catch(() => {
            this.changePasswordDialogLoading = false;
          });
      });
    },
    submitCreateUser() {
      this.$refs.createUserForm.validate().then(() => {
        let postBody = {
          userId: this.createUserModel.userId,
          userName: this.createUserModel.userName,
          password: this.createUserModel.password,
        };

        this.createUserFormLoading = true;
        this.$http
          .post("/user/InsertUser", postBody)
          .then(() => {
            this.createUserFormLoading = false;
            this.createUserDialogVisible = false;
            this.currentPage = 1;
            this.getData();
            this.$message({ message: "修改成功", type: "success" });
          })
          .catch(() => {
            this.createUserFormLoading = false;
          });
      });
    },
    submitImportReport() {
      let validatePromise = this.$refs.importForm.validate();
      validatePromise.then((res) => {
        this.loadingFullScreen = this.$loading({
          lock: true,
          text: "正在导入报告数据, 请您耐心等待...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.8)",
        });

        let postBody = {
          excelFileName: this.importFormModel.fileName,
          reportName: this.importFormModel.reportName,
        };
        this.$http
          .post("/report/submitReport", postBody)
          .then(() => {
            this.importDialogVisible = false;
            this.loadingFullScreen.close();
            this.$message({ message: "提交报告成功", type: "success" });
            this.currentPage = 1;
            this.getData();
          })
          .catch((err) => {
            this.loadingFullScreen.close();
          });
      });
    },
    triggerSetAuthBridge(userId) {
      if (userId === undefined || userId === "") {
        this.$message.error("用户ID为空");
        return;
      }

      let user = this.userIdUserDict[userId];
      if (user === undefined) {
        this.$message.error("无法找到目标用户数据");
        return;
      }

      let promiseList = [];
      if (this.bridgeIdBridgeNameDict === null) {
        promiseList.push(this.queryBridge());
      }
      Promise.all(promiseList).then(() => {
        this.setAuthBridgeModel.displayBridgeIdList = this.bridgeIdBridgeNameDictKeyList;
        this.setAuthBridgeModel.selectedBridgeList = user.authorisedBridgeList;
        this.setAuthBridgeModel.userId = user.userId;
        this.setAuthBridgeModel.isSetControllBridge = false;
        this.setAuthBridgeDialogVisible = true;
      });
    },
    triggerSetControllBridge(userId) {
      if (userId === undefined || userId === "") {
        this.$message.error("用户ID为空");
        return;
      }

      let user = this.userIdUserDict[userId];
      if (user === undefined) {
        this.$message.error("无法找到目标用户数据");
        return;
      }

      let promiseList = [];
      if (this.bridgeIdBridgeNameDict === null) {
        promiseList.push(this.queryBridge());
      }
      Promise.all(promiseList).then(() => {
        this.setAuthBridgeModel.displayBridgeIdList = user.authorisedBridgeList;
        this.setAuthBridgeModel.selectedBridgeList = user.controlledBridgeList;
        this.setAuthBridgeModel.userId = user.userId;
        this.setAuthBridgeModel.isSetControllBridge = true;
        this.setAuthBridgeDialogVisible = true;
      });
    },
    triggerChangePassword(userId) {
      if (userId === undefined || userId === "") {
        this.$message.error("用户ID为空");
        return;
      }

      let user = this.userIdUserDict[userId];
      if (user === undefined) {
        this.$message.error("无法找到目标用户数据");
        return;
      }

      this.changePasswordModel.userId = user.userId;
      this.changePasswordModel.userName = user.userName;
      this.changePasswordModel.newPassword = "";

      this.changePasswordDialogVisible = true;
    },
    triggerLoginHistory(userId) {
      if (userId === undefined || userId === "") {
        this.$message.error("用户ID为空");
        return;
      }

      let user = this.userIdUserDict[userId];
      if (user === undefined) {
        this.$message.error("无法找到目标用户数据");
        return;
      }

      this.$router.push("/admin/userLoginHistory?userId=" + userId);
    },
    hrefToOriginalExcel(reportId) {
      if (reportId === undefined || reportId === "") {
        this.$message.error("报告编号为空");
        return;
      }

      window.open("/report/DownloadOriginalExcel?reportId=" + reportId, "_blank");
    },
    hrefToExport(reportId) {
      if (reportId === undefined || reportId === "") {
        this.$message.error("报告编号为空");
        return;
      }

      this.$router.push("/surveyReport/generateReport?reportId=" + reportId);
    },
    handleUploadSuccess(res) {
      this.importFormLoading = false;
      this.importFormModel.fileName = res.fileName;
      this.$refs.importForm.validateField("fileName");
    },
    handleUploadRemove() {
      this.importFormModel.fileName = "";
    },
    handleUploadError(err) {
      this.importFormLoading = false;
      this.$message.error("文件上传失败，请刷新重试. " + err);
    },
    triggerCreateUserDialog() {
      this.createUserDialogVisible = true;
    },
    refreshData() {
      this.getData();
    },
    currentChange(index) {
      this.currentPage = index;
      this.getData();
    },
    getData() {
      this.loading = true;
      this.getDataCount();
      this.getDataList();
    },
    getDataCount() {
      let url = "/user/GetUserCount";

      this.$http.get(url).then((res) => {
        this.totalCount = res.data.count;
      });
    },
    getDataList() {
      let promiseList = [];
      if (this.bridgeIdBridgeNameDict === null) {
        promiseList.push(this.queryBridge());
      }

      Promise.all(promiseList).then(() => {
        let dataUrl = "/user/GetUserList?start=" + (this.currentPage - 1) * this.pageSize + "&limit=" + this.pageSize;

        this.$http.get(dataUrl).then((res) => {
          let dataList = res.data;

          dataList.forEach((dataItem) => {
            try {
              let date = newtonsoftJsonToDate(dataItem.lastLoginDate);
              dataItem.lastLoginDate = dateTimeToString(date, "yyyy-MM-dd HH:mm:ss");
            } catch(e) {
              //pass
            }
          });

          dataList.forEach((dataItem) => {
            if (dataItem.userType === "USER") {
              dataItem.userType = "一般用户";
            } else if (dataItem.userType === "ADMIN") {
              dataItem.userType = "管理员";
            }

            // if (dataItem.lastLoginLocation && dataItem.lastLoginIp) {
            //   dataItem.lastLoginIp += "(" + dataItem.lastLoginLocation + ")";
            // }
          });

          dataList.forEach((dataItem) => {
            let authBridgeNameList = [];
            dataItem.authorisedBridgeList.forEach((bridgeId) => {
              let bridgeName = this.bridgeIdBridgeNameDict[bridgeId];
              if (bridgeName !== undefined) {
                authBridgeNameList.push(bridgeName);
              } else {
                authBridgeNameList.push(bridgeId);
              }
            });

            let controllBridgeNameList = [];
            if (!dataItem.controlledBridgeList) {
              dataItem.controlledBridgeList = [];
            }
            dataItem.controlledBridgeList.forEach((bridgeId) => {
              let bridgeName = this.bridgeIdBridgeNameDict[bridgeId];
              if (bridgeName !== undefined) {
                controllBridgeNameList.push(bridgeName);
              } else {
                controllBridgeNameList.push(bridgeId);
              }
            });

            dataItem.authBridge = authBridgeNameList.join(", ");
            dataItem.controllBridge = controllBridgeNameList.join(", ");
          });

          dataList.forEach((dataItem) => {
            this.userIdUserDict[dataItem.userId] = dataItem;
          });

          this.tableData = dataList;
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
      });
    },
    async queryBridge() {
      await this.$http.get("/auth/loginInfo").then((res) => {
        this.bridgeIdBridgeNameDict = {};
        let authBridgeList = res.data.authorisedBridgeList;
        authBridgeList.forEach((bridgeId) => {
          let bridge = constantBridgeList[bridgeId];
          if (bridge) {
            this.bridgeIdBridgeNameDict[bridgeId] = bridge.name;
          }
        });
      });
    },
    async queryUser(userId) {
      await this.$http.get("/user/GetUserList?userId=" + userId).then((res) => {
        this.userTranslateDict[userId] = res.data[0].userName;
      });
    },
    async translateDataIdForDataList(refDataList, dataIdFieldName, translateResultFieldName, translateDictName, asyncQueryFunc) {
      let idDict = {};
      refDataList.forEach((dataItem) => {
        if (dataItem[dataIdFieldName] !== undefined) {
          const dataKey = dataItem[dataIdFieldName];
          idDict[dataKey] = true;
        }
      });

      if (this[translateDictName] === undefined) {
        this[translateDictName] = {};
      }
      const translateDict = this[translateDictName];

      let queryPromiseList = [];
      for (let id in idDict) {
        if (translateDict[id] === undefined) {
          queryPromiseList.push(asyncQueryFunc(id));
        }
      }

      await Promise.all(queryPromiseList).then(() => {
        refDataList.forEach((dataItem) => {
          const dataKey = dataItem[dataIdFieldName];
          if (dataKey !== undefined) {
            const translateResult = translateDict[dataKey];
            dataItem[translateResultFieldName] = translateResult;
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.report-list {
  margin-top: 20px;
  background-color: #fff;
  padding: 20px;
  // height: 784px !important;
  height: calc(100% - 50px) !important;
  position: relative;
  .table-command {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
  .pagination {
    position: absolute;
    bottom: 0;
  }
}
.status-tag {
  cursor: pointer;
}
.table-button {
  margin-top: 5px;
  margin-left: 5px;
}

::v-deep .el-pagination {
  text-align: center;
}
</style>
